import { MijnRoute } from '../../mijn-navigatie.model';

export const PAYMENT_BATCHES_RESULT: MijnRoute = {
    path: 'result',
    navigationEvent: 'toBetaalbatchesResult',
    regex: /^\/betaalbatches\/result$/,
    webcomponent: 'mijn-betalen-betaalbatches-webcomponent',
    internalPath: '/result'
};
